/**
 * Created by intellicar-rinas on 4/10/17.
 */
import  React, {Component} from 'react';
import './InDatePicker.css';
import moment from 'moment';
import {dateFormat,simpleTimeFormat} from '../../../../constants/constants';
const DateTime = require('./DateTime').default;

let format = dateFormat;
class InDatePicker extends Component{

    state = {
        uid:Math.random()
    };

    constructor(){
        super();

        this.initDatePicker = this.initDatePicker.bind(this);
        this.onChange = this.onChange.bind(this);
        this.getData = this.getData.bind(this);
        this.getRawValue = this.getRawValue.bind(this);
        this.setData = this.setData.bind(this);
    }



    initDatePicker(_ref){
        if(!_ref)
            return;

        DateTime(_ref).periodpicker({
            likeXDSoftDateTimePicker: true,
            norange: true, // use only one value
            cells: [1, 1], // show only one month
            resizeButton: false, // deny resize picker
            fullsizeButton: false,
            formatDateTime: format,
            fullsizeOnDblClick: false,
            timepicker: true, // use timepicker
            timepickerOptions: {
                hours: false,
                minutes: false,
                seconds: false,
                ampm: false
            },
            onOkButtonClick:function(){
                // onDateValueChange(this.options.idx, this.options.key)
            },
            ...this.props.config
        });

        this.value = _ref.value;
        if(this.props && this.props.data){
            if(window.currentValue){
                if(this.props.data.key === "starttime") {
                   this.props.data.model = window.currentValue.starttime
                }
                if(this.props.data.key === "endtime") {
                   this.props.data.model = window.currentValue.endtime
                }
            }
        }
    }

    isDateAvailable =timestamp=> {
        return this.props.data.allowFutureDate ? true : timestamp < Date.now();
    };

    validateDate =(callback=()=>{})=> {
        // if(this.props.source==="ev"){
        //     this.value=moment(this.value).startOf('day').format("DD-MMM-YYYY")
        // }
        let timestamp = moment(this.value, format).unix() * 1000;
        // console.log("validating date:",timestamp)
        if(this.isDateAvailable(timestamp)) {
            callback();
        } else {
            this.setData(Date.now() - 30000);
            this.onChange();
        }
    };

    onChange(){
        this.validateDate(()=>{
            if(this.props.data.hideTime && this.refs.input.value){
               this.refs.input.value=moment(this.refs.input.value).startOf('day').format("DD-MMM-YYYY HH:mm")
            }
            if(this.props.data && this.props.data.schemaKey && this.props.data.schemaKey === "hourly_report") {
                this.refs.input.value=moment(this.refs.input.value).startOf('day').format("DD-MMM-YYYY")    
            }
            // if(this.props.schemaKey && this.props.schemaKey === "download_report"){
            //     this.value = moment(this.value).format(format)
            //     this.refs.input.value = moment(this.refs.input.value).startOf('day').format(format)
            // }
            if(this.props.onChange){
                // if(this.props.data.hideTime && this.refs.input.value){
                //     this.value = moment(this.value).format(format)
                //     this.refs.input.value = moment(this.refs.input.value).startOf('day').format(format)
                // }
                this.props.onChange(moment(this.value, format),this.value);
            }
        });
    }

    getData(){
        return moment(this.value || this.refs.input.value, format);
    }

    getRawValue(){
        return this.value;
    }

    setData(timestamp){
        this.value = moment(timestamp).format(format);
        window[this.props.data.key + 'value'] = this.value;
        this.refs.input.value = moment(timestamp).format(format);
        this.validateDate();
    }



    componentDidMount(){
        // this.placeholder=this.model;
        document.addEventListener('mousedown', (e)=>{
            if(this.refs.input && (!this || this.value !== this.refs.input.value)){
                this.value = this.refs.input.value;
                this.value = moment(this.value).format(format);
                this.onChange();
            }
        });
        this.initDatePicker(this.refs.input);

        this.model=this.props.data.model;
        this.placeholder=this.model;
        if(this.model){
            if(!this.getRawValue()) {
                this.setData(this.model);
            }
        }
    }

    componentWillReceiveProps(props){
        // console.log(this.refs.input.value)
        this.props = props;
        this.value = null;
        if(props.data.hideTime && props.data.schemaKey === "daily_report" && this.refs.input.value){
            this.refs.input.value=moment(this.refs.input.value).startOf('day').format("DD-MMM-YYYY HH:mm")
        }
        if(props.data.hideTime && props.data.schemaKey === "can_daily_report" && this.refs.input.value){
            this.refs.input.value=moment(this.refs.input.value).startOf('day').format("DD-MMM-YYYY HH:mm")
        }
        if(props.data.hideTime && props.data.schemaKey === "hourly_report" && this.refs.input.value){
            this.refs.input.value=moment(this.refs.input.value).startOf('day').format("DD-MMM-YYYY")
        }
        // if(props.schemaKey && props.schemaKey === "download_report"){
        //     this.value = this.refs.input.value
        // }
        // else {
        //     this.value = null
        // }
        // console.log("this.refs.input.value",props,this.value)

        if(this.refs.input){
            if(!window[this.props.data.key + 'value']) {
                let ts = this.value ? moment(this.value, format).unix() * 1000 : props.data.model;
                this.setData(ts);
            }
        }
        // if(this.props.data.hideTime && this.refs.input.value){
        //     this.refs.input.value=moment(this.refs.input.value).format("DD-MMM-YYYY")
        //  }else{
            // this.refs.input.value=moment(this.refs.input.value).format("DD-MMM-YYYY HH:mm") 
        //  }
    }
    changeTimepicker = () => {
        let d =this.refs.input.value
      if(this.refs.input && this.props.data.hideTime ){
            // this.value = this.refs.input.value 
            DateTime(this.refs.input).periodpicker('destroy');
            DateTime(this.refs.input).periodpicker({
                likeXDSoftDateTimePicker: true,
                norange: true, // use only one value
                cells: [1, 1], // show only one month
                resizeButton: false, // deny resize picker
                fullsizeButton: false,
                formatDateTime: simpleTimeFormat,
                fullsizeOnDblClick: false,
                timepicker: false, // use timepicker
                timepickerOptions: {
                    hours: false,
                    minutes: false,
                    seconds: false,
                    ampm: false
                },
                onOkButtonClick:function(){
                    // onDateValueChange(this.options.idx, this.options.key)
                },
                ...this.props.config
            });
            this.refs.input.value = moment(d).format("DD-MMM-YYYY")
            this.value = this.refs.input.value
        }
        else{
                DateTime(this.refs.input).periodpicker('destroy');
                this.initDatePicker(this.refs.input);
                this.refs.input.value = moment(d).format("DD-MMM-YYYY HH:mm")
                this.value = this.refs.input.value
            
        }
    }
    render(){
        return (
            <div className="InDatePicker">
                <input ref="input" onChange={this.onChange} onFocus={this.changeTimepicker} placeholder={ 'Select Date'}/>
            </div>
        )
    }

}

export default InDatePicker;